// Generated by CoffeeScript 1.12.7
define('etc/participant_cache',['require','sp/locals','underscore'],function(require) {
  var ParticipantCache, clone, find, findIndex, locals, ref, reject;
  locals = require('sp/locals');
  ref = require('underscore'), reject = ref.reject, find = ref.find, findIndex = ref.findIndex, clone = ref.clone;

  /**
  	Manages participant cache.
  
  	@class ParticipantCache
   */
  return ParticipantCache = (function() {
    function ParticipantCache() {}


    /**
    		The cache key name
    
    		@name CACHE_NAME
    		@value "participants"
    		@static
    		@readOnly
     */

    ParticipantCache.CACHE_NAME = 'participants';


    /**
    		Constant used for wether the survey has already been taken by the
    		participant saved in local storage.
    
    		@property CACHE_SURVEY_COMPLETED_NAME
    		@type String
    		@static
    		@const
     */

    ParticipantCache.CACHE_SURVEY_COMPLETED_NAME = 'completed';

    ParticipantCache.set = function(participant) {
      var cache, participants;
      if (!participant) {
        return;
      }
      if (typeof participant.toJSON === 'function') {
        participant = participant.toJSON();
      } else {
        participant = clone(participant);
      }
      cache = locals.get(ParticipantCache.CACHE_NAME, []);
      participants = reject(cache, {
        survey: participant.survey
      });
      participants.push(participant);
      locals.set(ParticipantCache.CACHE_NAME, participants);
      return participant;
    };

    ParticipantCache.get = function(id, key) {
      var cache;
      if (key == null) {
        key = "survey";
      }
      cache = ParticipantCache.getAll();
      if (!cache || !cache.length) {
        return;
      }
      return find(cache, function(participant) {
        return participant[key] === id;
      });
    };

    ParticipantCache.remove = function(surveyId) {
      var cache, index;
      cache = ParticipantCache.getAll();
      if (!cache || !cache.length) {
        return;
      }
      index = findIndex(participants, {
        survey: surveyId
      });
      if (index >= 0) {
        participants.splice(index, 1);
      }
      return locals.set(ParticipantCache.CACHE_NAME, participants);
    };

    ParticipantCache.getAll = function() {
      return locals.get(ParticipantCache.CACHE_NAME, []);
    };

    ParticipantCache.clear = function() {
      return locals.remove(ParticipantCache.CACHE_NAME);
    };

    ParticipantCache.markComplete = function(surveyId, participantId) {
      var participant;
      participant = {};
      participant._id = participantId;
      participant.survey = surveyId;
      participant[ParticipantCache.CACHE_SURVEY_COMPLETED_NAME] = true;
      ParticipantCache.set(participant);
      return participant;
    };

    ParticipantCache.setSession = function(surveyId, session) {
      var participant;
      if (!surveyId || !surveyId.length) {
        return;
      }
      if (!session || !session.length) {
        return;
      }
      participant = ParticipantCache.get(surveyId);
      if (!participant) {
        return;
      }
      participant.session = session;
      ParticipantCache.set(participant);
      return participant;
    };

    ParticipantCache.getSession = function(surveyId) {
      var cache;
      cache = ParticipantCache.get(surveyId) || {};
      return cache.session;
    };

    return ParticipantCache;

  })();
});

